// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyMessage_container__1g9Aj","message":"EmptyMessage_message__1tizt"};